// states are there to avoid dependencies cycle
export const STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
  SINGLE_IMAGE: 'single_image',
  FILES: 'files',
};
